<template>
  <a-layout>
    <a-space>
      <a-select v-model="query['storer.id']" :placeholder="$t('business.label.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.receiptOrderNo')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['customer.name']" :placeholder="$t('business.label.customerName')" class="query" @pressEnter="search" @search="search"/>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('business.label.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('business.label.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="customer.name" title="business.label.customerName"/>
      <vxe-column field="asnOrder.orderStatus" title="business.label.orderStatus" width="100">
        <template slot-scope="{ row }">{{ orderStatusData.length === 0 ? row.asnOrder.orderStatus : orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name }}</template>
      </vxe-column>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <shelf-task ref="shelfTask" :scroll-y="taskScrollY"/>
  </a-layout>
</template>

<script>
import moment from 'moment'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import { findAll, findEnum } from '@/api/Api'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ShelfByOrder',
    components: {ShelfTask, PageUtil},
    data() {
      return {
        data: [],
        storerData: [],
        orderStatusData: [],
        contentSize: 0,
        page: 1,
        size: 5,
        loading: false,
        query: {
          'order.no': '',
          'customer.name': '',
          'storer.id': undefined,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        },
        args: null,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.25),
        taskScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.48)
      }
    },
    mounted() {
      findAll('storerFactory', {available: true}).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      disabledStartDate(startValue) {
        const endValue = this.query.dateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.dateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      rowClick(row) {
        this.$refs.shelfTask.getData({'order.no': row.order.no})
      },
      moment,
      getData() {
        this.loading = true
        let args = Object.assign({}, this.query)
        if (args.dateFilter.start === null && args.dateFilter.end === null) {
          args.dateFilter = null
        }
        findAll('receivingReceiptListFactory', args, this.page, this.size).then((res) => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            this.$refs.shelfTask.reset()
          }
        }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      reset() {
        this.page = 1
        this.size = 5
        this.contentSize = 0
        this.query = {
          'order.no': '',
          'customer.name': '',
          'storer.id': undefined,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        }
        this.getData()
      },
      confirm() {
        this.$refs.shelfTask.putaway()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }
</style>